export const howItWorksVideoId = 'MR-ixbEso2g';
export const smsfVideoId = 'cA7a78Vo2lk';
export const smartInvestVideoId = 'e9qRhpj1R9k';
export const howToSelectPropertyVideoId = 'NJS_y5Rgraw';
export const minorsVideoId = 'MQUjPT2wiY8';
